import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  filterButton: {
    width: 32,
    height: 32,
    padding: '6px 4px 2px 4px',
  },
  filterButtonIcon: {
    position: 'relative',
    // color: theme.colors.,
    height: 24,
    width: 24,
  },
  hasActiveFiltersBadge: {
    position: 'absolute',
    top: 10,
    left: '65%',
    width: 10,
    height: 10,
    color: theme.colors.success,
  },
  opened: {
    '&.MuiButtonBase-root': {
      backgroundColor: theme.colors.lightSelection,
    },
  },
}
));

export default useStyles;
